import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveChannel, selectGmlProjectionItems } from 'redux/channels';
import Utils from 'utilities/helper.util';
import customIcons from 'assets/icons';

export const SWXAutomateActiveChannelComponent: React.FC<any> = () => {
  const gmlProjectionOptions: any = useSelector(selectGmlProjectionItems);
  const activeChannels: any = useSelector(selectActiveChannel);
  const [startedLiveAt, setStartedLiveAt] = useState<string | undefined>('-');

  useEffect(() => {
    if (activeChannels && !Utils.isObjectEmpty(activeChannels)) {
      const startLiveDate = Utils.toLocalDateTimeFormat(
        activeChannels.startedLiveAt || activeChannels.updatedAt
      );

      startLiveDate && setStartedLiveAt(startLiveDate);
    }
  }, [activeChannels, gmlProjectionOptions]);

  return (
    <>
      <div className="section__top">
        <img
          src={customIcons.SWXAutomateIcon}
          width="22"
          height="24"
          alt="Global partner"
        />
        <div className="section__body">
          <h2 className="section__sub-heading">
            SmarterWX Automate is your active referral channel
          </h2>
          <p className="section__label">
            Channel types include Email, Web Hook and SmarterWX Automate
          </p>
        </div>
        <hr className="section__divider" />
      </div>

      <div className="section__summary">
        <h4 className="section__sub-heading">Summary</h4>
        <div className="section__sub">
          <div className="section__label">Date activated</div>
          <p className="section__text">{startedLiveAt}</p>
        </div>
        <hr className="section__divider" />
      </div>
    </>
  );
};
export default SWXAutomateActiveChannelComponent;
